import styled from 'styled-components';

import { Row } from 'components/Grid';
import Button from 'components/Button';

export const Container = styled.div`
  width: 90%;
  height: fit-content;
  max-width: 680px;
  border-radius: 12px;
  padding: 24px 20px 32px 20px;
  margin: 50px 0;
  background-color: #fafafa;
`; 

export const Header = styled(Row)`
  margin: 0 !important;
`;

export const Title = styled.h4`
  font-weight: 600;
  margin-bottom: 20px;
  color: #ff441f;
`;

export const Subtitle = styled.h5`
  color: #626e75;
  margin-bottom: 22px;
`;

export const CloseButton = styled.img`
  height: 16px;
  margin-left: auto;
  cursor: pointer;
`;

export const SubmitButton = styled(Button)`
  max-width: 303px;
`;
